"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FolderQuestionSolid: function() {
        return FolderQuestionSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const FolderQuestionSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M4 3C2.34315 3 1 4.34315 1 6V18C1 19.6569 2.34315 21 4 21H20C21.6569 21 23 19.6569 23 18V8C23 6.34315 21.6569 5 20 5H12.6056C12.4081 5 12.2151 4.94156 12.0509 4.83205L10.0585 3.50385C9.56575 3.17531 8.98672 3 8.39445 3H4ZM10.9687 10.9993C11.0797 10.5677 11.4726 10.25 11.9372 10.25C12.4895 10.25 12.9372 10.6977 12.9372 11.25C12.9372 11.4232 12.8917 11.5553 12.6178 11.8197C12.4834 11.9494 12.3282 12.0782 12.1236 12.248L12.0321 12.324C11.7938 12.5223 11.5143 12.7587 11.2301 13.0429C10.8396 13.4334 10.8396 14.0666 11.2301 14.4571C11.6207 14.8476 12.2538 14.8476 12.6444 14.4571C12.8602 14.2413 13.0807 14.0533 13.3111 13.8616L13.3969 13.7905C13.5943 13.6269 13.8139 13.4449 14.0067 13.2587C14.4827 12.7993 14.9372 12.1814 14.9372 11.25C14.9372 9.59315 13.5941 8.25 11.9372 8.25C10.538 8.25 9.36478 9.20704 9.03181 10.5007C8.89414 11.0356 9.21613 11.5808 9.75098 11.7184C10.2858 11.8561 10.831 11.5341 10.9687 10.9993ZM11.9377 15.25C11.3855 15.25 10.9377 15.6977 10.9377 16.25C10.9377 16.8023 11.3855 17.25 11.9377 17.25H11.9477C12.5 17.25 12.9477 16.8023 12.9477 16.25C12.9477 15.6977 12.5 15.25 11.9477 15.25H11.9377Z",
        fill: "currentColor"
    })
}), "FolderQuestionSolid");
const _default = FolderQuestionSolid;
